import React from 'react';
import { defineMessages } from 'react-intl';
import { useFormatMessage } from '../../i18n-review/client/Msg';
import { BenefitsList } from '../benefits/BenefitsList';

const messages = defineMessages({
  heading: {
    id: 'companyProfile.commonBenefits.heading',
    defaultMessage: 'Common benefits',
    description:
      'Heading of the company profile card listing benefits that appear on nearly all of this company\'s currently-active job postings',
  },
});

interface CommonBenefitsCardProps {
  /** Benefit labels appearing on at least 80% of the company's active jobs (see
   * fetchCompanyCommonBenefits), already sorted most-common first, locale-native. */
  benefits?: string[];
  className?: string;
}

/**
 * Benefits derived from the company's OWN job postings (not the free-text site-scrape
 * `company.benefits` CompanyFactsCard shows): a companion card, not a merge into that one,
 * since the two have different data sources and refresh cadences. Self-hides when there's
 * nothing to show, same convention as CompanyFactsCard.
 */
export function CommonBenefitsCard({ benefits, className = '' }: CommonBenefitsCardProps) {
  const formatMessage = useFormatMessage();
  if (!benefits || benefits.length === 0) return null;

  return (
    <div
      className={`rounded-2xl border border-[#DDD5C8] bg-white shadow-sm dark:border-[#4A3520] dark:bg-[#1F1509] p-4 sm:p-5 ${className}`}
    >
      <h2 className="text-base font-semibold text-[#1E1A14] dark:text-[#F2EADF]">
        {formatMessage(messages.heading)}
      </h2>
      <div className="mt-3">
        <BenefitsList benefits={benefits} maxItems={benefits.length} iconSize="md" itemClassName="text-sm" />
      </div>
    </div>
  );
}

CommonBenefitsCard.displayName = 'CommonBenefitsCard';
